/**
 *
 * Header
 *
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import { setLanguage, setLogout, setNav, setNotificationToken } from "store/actions";
import { Dropdown, Menu } from "antd";
import { Breadcrumb, DndControl, Icons } from "components";
import Socket from "utils/sockets";
import Strings from "utils/strings";

import "./styles.scss";
import { API, Endpoints } from "utils/api";

/* eslint-disable react/prefer-stateless-function */
export class Header extends Component<any, any> {
	constructor(props: any) {
		super(props);
		this.state = {
			open: false,
			isMobile: window.innerWidth < 768
		};

		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.handleResize = this.handleResize.bind(this);
		window.addEventListener("resize", this.handleResize);
	}

	componentDidMount() {
		this.handleResize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.handleResize);
	}

	toggleSidebar() {
		const { onToggleSidebar } = this.props;
		onToggleSidebar();
	}

	logout() {
		const { dispatch, notificationToken } = this.props;

		API.post({
			url: Endpoints.uriLogout(),
			data: {
				notificationToken
			}
		});

		Socket.close();
		localStorage.removeItem("token");
		dispatch(setLogout());
		dispatch(push("/"));
	}

	handleResize() {
		this.setState({ isMobile: window.innerWidth < 768 });
	}

	getLanguage(language: string) {
		if (language === "pt") return Strings.language.portuguese;
		else if (language === "es") return Strings.language.spanish;
		return Strings.language.english;
	}

	async changeLanguage(lang: string) {
		const { dispatch, notificationToken } = this.props;

		dispatch(setLanguage(lang));
		dispatch(setNotificationToken(notificationToken));

		await API.post({
			url: Endpoints.uriNotificationToken(),
			data: {
				notificationToken,
				device: "web",
				language: lang
			}
		});
	}

	renderOptions() {
		const { dispatch, language } = this.props;

		const menu = (
			<Menu
				items={[
					{
						label: Strings.language.portuguese,
						key: "1",
						style: {
							height: 40,
							display: "flex",
							alignItems: "center"
						},
						onClick: () => {
							this.changeLanguage("pt");
						}
					},
					{
						key: "separator",
						style: {
							height: 1,
							backgroundColor: "#EEE",
							padding: 0
						}
					},
					{
						label: Strings.language.english,
						key: "2",
						style: {
							height: 40,
							display: "flex",
							alignItems: "center"
						},
						onClick: () => {
							this.changeLanguage("en");
						}
					},
					{
						key: "separator2",
						style: {
							height: 1,
							backgroundColor: "#EEE",
							padding: 0
						}
					},
					{
						label: Strings.language.spanish,
						key: "3",
						style: {
							height: 40,
							display: "flex",
							alignItems: "center"
						},
						onClick: () => {
							this.changeLanguage("es");
						}
					}
				]}
			/>
		);

		return (
			<div className="HeaderOptions">
				<DndControl variant="header" />
				<Dropdown overlay={menu} trigger={["click"]}>
					<div className="HeaderLanguagePicker">
						<p>{this.getLanguage(language)}</p>
						<Icons.Caret />
					</div>
				</Dropdown>
				<button className="HeaderIcon" onClick={() => dispatch(push("/contact-us"))}>
					<Icons.Message />
				</button>
				<button className="HeaderIcon" onClick={() => this.logout()}>
					<Icons.Door />
				</button>
			</div>
		);
	}

	render() {
		const { mobile, dispatch } = this.props;

		if (mobile) {
			return (
				<div className="HeaderContainer --mobile">
					<div id="AppHeader" className="Header">
						<button className="MenuIcon" onClick={() => dispatch(setNav(true))}>
							<Icons.Menu />
						</button>
					</div>
				</div>
			);
		}

		return (
			<React.Fragment>
				<div className="HeaderContainer">
					<div id="AppHeader" className="Header">
						{this.renderOptions()}
					</div>
				</div>
				<Breadcrumb />
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: any) => ({
	router: state.router,
	title: state.title,
	user: state.user,
	language: state.language,
	settings: state.settings,
	mobile: state.mobile,
	notificationToken: state.notificationToken
});

export default connect(mapStateToProps)(Header);
